"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _Typography = require("../Typography");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 15px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  font-weight: 400;\n\n  @media print, screen and (min-width: ", "px) {\n    font-family: ", ";\n    font-weight: 700;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 8px;\n\n  @media print, screen and (min-width: ", "px) {\n    margin-bottom: 40px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.header(_templateObject(), _Constant.Width.MD);

var H1 = (0, _styledComponents.default)(_Typography.Typography.Header)(_templateObject2(), _Constant.Font.HEADER_FONT, _Constant.Width.MD, _Constant.Font.SECONDARY_HEADER_FONT);
var H3 = (0, _styledComponents.default)(_Typography.Typography.SpecificityHeader)(_templateObject3());

var MainHeader = function MainHeader(_ref) {
  var text = _ref.text,
      subText = _ref.subText;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(H1, null, text), subText && /*#__PURE__*/_react.default.createElement(H3, null, subText));
};

MainHeader.propTypes = {
  text: _propTypes.default.string.isRequired,
  subText: _propTypes.default.string
};
MainHeader.defaultProps = {
  subText: ''
};
var _default = MainHeader;
exports.default = _default;